export default __webpack_public_path__ + "static/better-2c8e9d25dc377ab63bd2fbc2b77300a4.png";